import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import useOnboardingSx from '../../hooks/useOnboardingSx';

export default function FormSection({ icon, title, description, children }) {
  const sx = useOnboardingSx();

  return (
    <Box>
      <Stack direction="row" spacing={1.5} alignItems="flex-start" sx={{ mb: 2 }}>
        <Box sx={sx.sectionIcon}>{icon}</Box>
        <Box>
          <Typography variant="subtitle1" fontWeight={600}>
            {title}
          </Typography>
          {description && (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
              {description}
            </Typography>
          )}
        </Box>
      </Stack>
      {children}
    </Box>
  );
}
